import { PlateSampleParamType } from '@/common/queries/selections/plateSample/plateSample.type';
import { getPlateSampleFunction } from '@/common/queries/selections/plateSample/plateSampleFunction';
import { queryOptions } from '@tanstack/react-query';

export const getPlateSampleOption = (param: PlateSampleParamType) =>
  queryOptions({
    queryKey: ['get_vehicle_plate-sample', param],
    queryFn: () => getPlateSampleFunction(param),
  });
